<template>
  <div class="merged-page" :class="{ dark: isActive }">
    <Card class="book-shell" :class="{ dark: isActive }">
      <div class="book-header">
       
        <div class="book-summary">
          <Tag color="blue">商店 {{ shopList.length }}</Tag>
          <Tag color="gold">珍宝 {{ currentSynthesisList.length }}</Tag>
          <Button size="small" type="info" ghost @click="refreshAll">刷新</Button>
        </div>
      </div>

      <div class="book-body">
        <section class="book-page left-page">
          <div class="page-head">
            <h3>每日商店</h3>
            <p>今日上架可直接购买的物品</p>
          </div>
          <div class="item-grid">
            <Poptip
              v-for="item in shopList"
              :key="'shop-' + item.marketId"
              :trigger="isMobile ? 'click' : 'hover'"
              transfer
              placement="right"
              popper-class="book-popper"
            >
              <div class="item-card" :class="{ dark: isActive }">
                <p class="item-name" :style="{ color: distinguishColor(item.color) }">{{ item.marketName }}</p>
                <p class="item-line">剩余 {{ item.marketNum || 0 }} 次</p>
                <p class="item-line" v-if="item.marketPrice">价格 {{ item.marketPrice }} {{ priceTypeText(item.priceType) }}</p>
                <div class="item-actions">
                  <Button size="small" type="info" ghost @click.stop="purchaseItem(item)">购买</Button>
                  <Button size="small" type="primary" @click.stop="openShopBatch(item)">批量</Button>
                </div>
              </div>
              <div slot="content" class="tip-content">
                <p>{{ item.marketName }}</p>
                <p v-if="item.marketDec">{{ item.marketDec }}</p>
                <p>剩余次数：{{ item.marketNum || 0 }}</p>
                <p>最低等级：{{ item.marketLevel || '无限制' }}</p>
                <p>价格：{{ item.marketPrice ? `${item.marketPrice} ${priceTypeText(item.priceType)}` : '-' }}</p>
                <p v-if="item.typeDec">类型：{{ item.typeDec }}</p>
                <p v-if="item.life">生命：{{ item.life }}</p>
                <p v-if="item.mana">真气：{{ item.mana }}</p>
                <p v-if="item.attack">攻击：{{ item.attack }}</p>
                <p v-if="item.magAttack">灵攻：{{ item.magAttack }}</p>
                <p v-if="item.defense">防御：{{ item.defense }}</p>
                <p v-if="item.magicDefense">法防：{{ item.magicDefense }}</p>
              </div>
            </Poptip>
          </div>
          <div v-if="!shopList.length" class="page-empty">暂无商品</div>
        </section>

        <section class="book-page right-page">
          <div class="page-head">
            <h3>珍宝阁</h3>
            <p>分类筛选后进行合成</p>
          </div>
          <div class="synthesis-tabs">
            <Button
              v-for="tab in synthesisTabs"
              :key="tab.type"
              size="small"
              :type="currentType === tab.type ? 'primary' : 'default'"
              @click="switchType(tab.type)"
            >
              {{ tab.name }} ({{ synthesisCount(tab.type) }})
            </Button>
          </div>
          <div class="item-grid">
            <Poptip
              v-for="item in currentSynthesisList"
              :key="'syn-' + item.syntheticId"
              :trigger="isMobile ? 'click' : 'hover'"
              transfer
              placement="left"
              popper-class="book-popper"
            >
              <div class="item-card synthesis-card" :class="{ dark: isActive }">
                <div class="mask">
                  <Tag :color="qualityTagColor(item.color)" class="tag" size="small">
                    {{ qualityLabel(item.color) }}
                  </Tag>
                </div>
                <div class="content-area">
                  <h4 class="item-name synthesis-item-name" :title="item.syntheticName">{{ item.syntheticName }}</h4>
                  <div class="item-limit">
                    <!-- <Icon type="ios-repeat" size="14" /> -->
                    剩余{{ item.syntheticNum > 999 ? "无限制" : item.syntheticNum }}次
                  </div>
                  <div class="item-limit realm-line" :title="`最低境界：${item.syntheticRealm || '无限制'}`">
                      <Icon type="ios-flame-outline" />
                      <span>{{ shortRealmText(item.syntheticRealm) }}</span>
                  </div>
                  <div class="item-limit" v-if="item.coin">
                      <span>消耗灵石：{{ item.coin }}</span>
                  </div>

                  <!-- <div class="mater-preview">
                    <div
                      v-for="(mat, idx) in synthesisMaterials(item).slice(0, 3)"
                      :key="`${item.syntheticId}-mat-${idx}`"
                      class="mat-item"
                      :title="`${mat.name} x${mat.num}`"
                    >
                      {{ mat.name }}×{{ mat.num }}
                    </div>
                    <div v-if="!synthesisMaterials(item).length" class="mat-item">暂无材料要求</div>
                  </div> -->
                  <div class="action-buttons">
                    <Button size="small" type="primary" :disabled="item.syntheticNum === 0" @click.stop="synthesisItem(item)">合成</Button>
                    <Button size="small" :disabled="item.syntheticNum === 0" @click.stop="openSynthesisBatch(item)">批量</Button>
                  </div>
                </div>
              </div>
              <div slot="content" class="tip-content">
                <p>{{ item.syntheticName }}</p>
                <p v-if="item.syntheticDesci">{{ item.syntheticDesci }}</p>
                <p>剩余次数：{{ item.syntheticNum > 999 ? '无限制' : item.syntheticNum }}</p>
                <p>最低境界：{{ item.syntheticRealm || '无限制' }}</p>
                <p v-if="item.coin">消耗灵石：{{ item.coin }}</p>
                <p>需要等级：{{ item.syntheticLevel || '无限制' }}</p>
                <p v-if="synthesisMaterials(item).length">需求材料：{{ synthesisMaterials(item).map((mat) => `${mat.name}x${mat.num}`).join("、") }}</p>
              </div>
            </Poptip>
          </div>
          <div v-if="!currentSynthesisList.length" class="page-empty">当前分类暂无可合成内容</div>
        </section>
      </div>
    </Card>

    <Drawer v-model="detailDrawer" :title="drawerTitle" width="420" :closable="true">
      <div class="drawer-content" v-if="selectedItem">
        <div class="drawer-section">
          <p class="drawer-section-title">基础信息</p>
          <p v-for="detail in selectedItemDetails" :key="detail.label">{{ detail.label }}：{{ detail.value }}</p>
        </div>
        <div class="drawer-section" v-if="selectedItemDesc">
          <p class="drawer-section-title">描述</p>
          <p>{{ selectedItemDesc }}</p>
        </div>
        <div class="drawer-actions">
          <Button v-if="selectedType === 'shop'" type="info" @click="purchaseItem(selectedItem)">立即购买</Button>
          <Button v-if="selectedType === 'shop'" @click="openShopBatch(selectedItem)">批量购买</Button>
          <Button v-if="selectedType === 'synthesis'" type="info" @click="synthesisItem(selectedItem)">立即合成</Button>
          <Button v-if="selectedType === 'synthesis'" @click="openSynthesisBatch(selectedItem)">批量合成</Button>
        </div>
      </div>
    </Drawer>

    <Modal
      v-model="batchEject"
      width="360"
      :title="batchTitle"
      @on-ok="confirmBatchAction"
    >
      <Input v-model="batchNum" type="number" placeholder="请输入数量" />
    </Modal>
  </div>
</template>

<script>
import Im from "./Im";

export default {
  name: "synthesisNew",
  data() {
    return {
      synthesisTabs: [
        { type: 2, name: "限时活动" },
        { type: 1, name: "丹方" },
        { type: 3, name: "材料" },
        { type: 4, name: "秘籍" },
        { type: 5, name: "真灵书" },
      ],
      currentType: 1,
      shopList: [],
      synthesisList: [],
      synthesisList1: [],
      synthesisList2: [],
      synthesisList3: [],
      synthesisList4: [],
      synthesisList5: [],
      batchEject: false,
      batchNum: 1,
      marketId: "",
      syntheticId: "",
      batchActionType: "",
      detailDrawer: false,
      selectedType: "",
      selectedItem: null,
      isMobile: false,
    };
  },
  computed: {
    isActive() {
      return window.localStorage.getItem("isTheme") === "black";
    },
    currentSynthesisList() {
      const map = {
        4: this.synthesisList4,
        2: this.synthesisList1,
        3: this.synthesisList2,
        1: this.synthesisList3,
        5: this.synthesisList5,
      };
      return map[this.currentType] || [];
    },
    drawerTitle() {
      if (!this.selectedItem) return "详情";
      return this.selectedType === "shop" ? `商店详情 - ${this.selectedItem.marketName}` : `合成详情 - ${this.selectedItem.syntheticName}`;
    },
    batchTitle() {
      return this.batchActionType === "shop" ? "批量购买" : "批量合成";
    },
    selectedItemDesc() {
      if (!this.selectedItem) return "";
      return this.selectedType === "shop" ? this.selectedItem.marketDec : this.selectedItem.syntheticDesci;
    },
    selectedItemDetails() {
      if (!this.selectedItem) return [];
      if (this.selectedType === "shop") {
        return this.buildShopDetail(this.selectedItem);
      }
      return this.buildSynthesisDetail(this.selectedItem);
    },
  },
  created() {
    this.checkMobile();
    this.refreshAll();
  },
  mounted() {
    window.addEventListener('resize', this.checkMobile);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkMobile);
  },
  methods: {
    checkMobile() {
      const responsive = this.$store && this.$store.state && this.$store.state.responsive
        ? this.$store.state.responsive
        : null;
      this.isMobile = responsive ? !!responsive.isMobile : window.innerWidth <= 768;
    },
    refreshAll() {
      this.loadShopList();
      this.loadSynthesisList();
    },
    switchType(type) {
      this.currentType = type;
    },
    synthesisCount(type) {
      const map = {
        4: this.synthesisList4,
        2: this.synthesisList1,
        3: this.synthesisList2,
        1: this.synthesisList3,
        5: this.synthesisList5,
      };
      return (map[type] || []).length;
    },
    distinguishColor(color) {
      if (color == 1) return "#8c94a4";
      if (color == 2) return "#879f1e";
      if (color == 3) return "#078599e0";
      if (color == 4) return "#036cbee0";
      if (color == 5) return "#801DAE";
      if (color == 6) return "#9e0e42e0";
      if (color == 7) return "#FFA631";
      return "#515a6e";
    },
    priceTypeText(type) {
      return type == 0 ? "金币" : "灵石";
    },
    shortRealmText(value) {
      const text = String(value || "无限制");
      if (text === "无限制") return "不限";
      return text
        .replace(/境初期$/, "·初")
        .replace(/境中期$/, "·中")
        .replace(/境后期$/, "·后")
        .replace(/境界$/, "");
    },
    typeText(type) {
      const map = {
        1: "丹方",
        2: "道具箱子",
        3: "材料",
        4: "秘籍",
        5: "真灵书",
      };
      return map[type] || "未知";
    },
    qualityLabel(color) {
      const map = {
        1: "普品",
        2: "良品",
        3: "上品",
        4: "极品",
        5: "史诗",
        6: "传说",
        7: "神话",
      };
      return map[color] || "未知";
    },
    qualityTagColor(color) {
      const map = {
        1: "default",
        2: "green",
        3: "blue",
        4: "#0D8767BF",
        5: "purple",
        6: "red",
        7: "orange",
      };
      return map[color] || "default";
    },
    synthesisMaterials(item) {
      const list = [];
      if (item.materOneName) list.push({ name: item.materOneName, num: item.materOneNum || 0 });
      if (item.materTwoName) list.push({ name: item.materTwoName, num: item.materTwoNum || 0 });
      if (item.materThreeName) list.push({ name: item.materThreeName, num: item.materThreeNum || 0 });
      if (item.syntheticMoney) list.push({ name: "金币", num: item.syntheticMoney });
      if (item.syntheticCoin) list.push({ name: "灵石", num: item.syntheticCoin });
      return list;
    },
    buildShopDetail(item) {
      return [
        { label: "价格", value: item.marketPrice ? `${item.marketPrice} ${this.priceTypeText(item.priceType)}` : "-" },
        { label: "剩余次数", value: item.marketNum || 0 },
        { label: "最低等级", value: item.marketLevel || "-" },
        { label: "类型", value: item.typeDec || "-" },
        { label: "装备等级", value: item.level || "-" },
        { label: "生命", value: item.life || "-" },
        { label: "真气", value: item.mana || "-" },
        { label: "攻击", value: item.attack || "-" },
        { label: "灵攻", value: item.magAttack || "-" },
        { label: "防御", value: item.defense || "-" },
        { label: "法防", value: item.magicDefense || "-" },
      ];
    },
    buildSynthesisDetail(item) {
      const materialText = this.synthesisMaterials(item).map((mat) => `${mat.name}x${mat.num}`).join("、") || "-";
      return [
        { label: "分类", value: this.typeText(item.syntheticType) },
        { label: "产物", value: item.syntheticName || "-" },
        { label: "需要等级", value: item.syntheticLevel || "-" },
        { label: "需求数量", value: item.syntheticNum || "-" },
        { label: "需求金币", value: item.syntheticMoney || 0 },
        { label: "需求灵石", value: item.syntheticCoin || 0 },
        { label: "需求材料", value: materialText },
      ];
    },
    openDetail(type, item) {
      this.selectedType = type;
      this.selectedItem = item;
      this.detailDrawer = true;
    },
    openShopBatch(item) {
      this.batchActionType = "shop";
      this.marketId = item.marketId;
      this.batchNum = item.marketNum || 1;
      this.batchEject = true;
    },
    openSynthesisBatch(item) {
      this.batchActionType = "synthesis";
      this.syntheticId = item.syntheticId;
      this.batchNum = item.syntheticNum || 1;
      this.batchEject = true;
    },
    confirmBatchAction() {
      if (this.batchActionType === "shop") {
        this.bulkPurchase();
      } else {
        this.bulkSynthesis();
      }
    },
    loadShopList() {
      this.$http
        .post("/gameMarket/waresList?charaId=" + this.getCookie("charaId"))
        .then((res) => {
          this.shopList = res.data.data || [];
        });
    },
    purchaseItem(item) {
      this.$http
        .post(
          "/gameMarket/buyWares?charaId=" +
            this.getCookie("charaId") +
            "&waresId=" +
            item.marketId +
            "&waresNum=1"
        )
        .then((res) => {
          this.$Notice.warning({ title: res.data.msg });
          Im.methods.send2(
            Im.data().chatUser,
            res.data.msg,
            Im.data().chatPindao,
            "系统消息",
            Im.data().socketObj
          );
          this.$bus.$emit("shopMsg", "商店购买完成");
          this.loadShopList();
        })
        .catch((err) => {
          this.$Notice.warning({ title: err.data.msg });
        });
    },
    bulkPurchase() {
      this.$http
        .post(
          "/gameMarket/buyWares?charaId=" +
            this.getCookie("charaId") +
            "&waresId=" +
            this.marketId +
            "&waresNum=" +
            this.batchNum
        )
        .then((res) => {
          this.$Notice.warning({ title: res.data.msg });
          this.$bus.$emit("shopMsg", "商店购买完成");
          this.loadShopList();
          this.$bus.$emit("shopMsg1", "商店批量购买完成");
        })
        .catch((err) => {
          this.$Notice.warning({ title: err.data.msg });
        });
    },
    loadSynthesisList() {
      this.$http
        .post("/gameRealm/getSyntheticList?charaId=" + this.getCookie("charaId"))
        .then((res) => {
          this.synthesisList = res.data.data || [];
          this.synthesisList1 = [];
          this.synthesisList2 = [];
          this.synthesisList3 = [];
          this.synthesisList4 = [];
          this.synthesisList5 = [];
          this.synthesisList.forEach((item) => {
            switch (item.syntheticType) {
              case 4:
                this.synthesisList4.push(item);
                break;
              case 2:
                this.synthesisList1.push(item);
                break;
              case 3:
                this.synthesisList2.push(item);
                break;
              case 1:
                this.synthesisList3.push(item);
                break;
              case 5:
                this.synthesisList5.push(item);
                break;
              default:
                break;
            }
          });
        });
    },
    synthesisItem(item) {
      this.$http
        .post(
          `/gameRealm/breakThroughTheSynthetic?charaId=${this.getCookie("charaId")}&syntheticId=${item.syntheticId}&syntheticNum=1`
        )
        .then((res) => {
          this.$Notice.success({ title: res.data.msg });
          this.loadSynthesisList();
          this.$bus.$emit("synthesisMsg", "合成成功");
        })
        .catch(() => this.$Notice.error({ title: "合成失败" }));
    },
    bulkSynthesis() {
      this.$http
        .post(
          `/gameRealm/breakThroughTheSynthetic?charaId=${this.getCookie("charaId")}&syntheticId=${this.syntheticId}&syntheticNum=${this.batchNum}`
        )
        .then((res) => {
          this.$Notice.success({ title: res.data.msg });
          this.loadSynthesisList();
          this.$bus.$emit("synthesisMsg1", "批量合成完成");
        })
        .catch(() => this.$Notice.error({ title: "批量合成失败" }));
    },
  },
};
</script>

<style scoped>
.merged-page {
  padding: 12px;
  background: #f5f7f9;
}

.merged-page.dark {
  background: #141823;
}

.book-shell {
  border-radius: 12px;
  border: 1px solid #e8eaec;
  background: #ffffff;
}

.book-shell.dark {
  border-color: #373e57;
  background: #1f2335;
}

.book-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 12px;
  margin-bottom: 14px;
}

.book-title {
  margin: 0;
  font-size: 20px;
  font-weight: 700;
  color: #17233d;
}

.book-subtitle {
  margin: 4px 0 0;
  color: #808695;
  font-size: 12px;
}

.book-summary {
  display: flex;
  align-items: center;
  gap: 8px;
}

.book-body {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px;
}

.book-page {
  border: 1px solid #e8eaec;
  border-radius: 10px;
  background: #ffffff;
  padding: 12px;
  display: flex;
  flex-direction: column;
}

.page-head h3 {
  margin: 0;
  font-size: 16px;
  color: #17233d;
}

.page-head p {
  margin: 4px 0 10px;
  color: #808695;
  font-size: 12px;
}

.synthesis-tabs {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-bottom: 10px;
}

.item-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 10px;
  height: 460px;
  overflow-y: auto;
  overflow-x: hidden;
  padding-right: 4px;
  align-content: start;
}

.right-page .item-grid {
  grid-template-columns: repeat(4, minmax(0, 1fr));
}

.item-card {
  border: 1px solid #e8eaec;
  border-radius: 8px;
  background: #ffffff;
  padding: 10px;
  cursor: pointer;
  height: 128px;
  min-height: 128px;
  max-height: 128px;
  display: flex;
  flex-direction: column;
  transition: all 0.2s ease;
}

.item-grid::-webkit-scrollbar {
  width: 6px;
}

.item-grid::-webkit-scrollbar-thumb {
  background: rgba(45, 140, 240, 0.35);
  border-radius: 6px;
}

.item-grid::-webkit-scrollbar-track {
  background: rgba(45, 140, 240, 0.08);
}

.item-card:hover {
  border-color: #5cadff;
  box-shadow: 0 5px 16px rgba(45, 140, 240, 0.15);
  transform: translateY(-1px);
}

.item-card.dark {
  background: #252b3c;
  border-color: #3d455d;
}

.item-name {
  margin: 0;
  font-size: 14px;
  font-weight: 700;
}

.synthesis-card {
  border-radius: 6px;
  overflow: visible;
  border: 1px solid #e8eaec;
  padding: 6px;
  height: 138px;
  width: 135px;
  min-height: 138px;
  max-height: 138px;
}

.synthesis-item-name {
  margin: 0 0 4px 0;
  font-size: 13px;
  line-height: 1.2;
  height: 2.4em;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

.synthesis-card .mask {
  position: relative;
  top: 2px;
  left: 2px;
  right: 2px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  z-index: 1;
}

.synthesis-card .tag {
  font-size: 10px;
  padding: 0 4px;
  height: 18px;
  line-height: 18px;
}

.synthesis-card .content-area {
  flex: 1;
  padding-top: 8px;
  display: flex;
  flex-direction: column;
}

  .synthesis-card .item-limit {
  display: flex;
  align-items: center;
  gap: 2px;
  font-size: 10px;
  color: #999;
  margin-bottom: 6px;
}

.item-line {
  margin: 6px 0 0;
  font-size: 12px;
  color: #515a6e;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.synthesis-card .mater-preview {
  height: 42px;
  min-height: 42px;
  max-height: 42px;
  margin-bottom: 6px;
  overflow: hidden;
}

.synthesis-card .mat-item {
  font-size: 10px;
  color: #666;
  line-height: 1.3;
  margin-bottom: 2px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.synthesis-card .action-buttons {
  display: flex;
  gap: 4px;
}

.synthesis-card .action-buttons .ivu-btn {
  font-size: 10px;
  padding: 2px 6px;
  height: 22px;
  flex: 1;
}

.item-actions {
  margin-top: auto;
  display: flex;
  gap: 8px;
}

.tip-content p {
  margin: 0 0 6px;
  font-size: 12px;
  line-height: 1.5;
}

.tip-hint {
  color: #2d8cf0;
}

.tip-mat {
  color: #515a6e;
}

.page-empty {
  margin-top: 12px;
  text-align: center;
  color: #808695;
  font-size: 12px;
}

.drawer-content {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.drawer-section {
  border: 1px solid #e8eaec;
  border-radius: 8px;
  padding: 10px;
}

.drawer-section-title {
  margin: 0 0 8px;
  font-weight: 700;
}

.drawer-section p {
  margin: 4px 0;
  font-size: 13px;
  line-height: 1.5;
}

.drawer-actions {
  display: flex;
  gap: 8px;
}

.dark .book-title,
.dark .page-head h3 {
  color: #d7def7;
}

.dark .book-subtitle,
.dark .page-head p,
.dark .item-line,
.dark .page-empty {
  color: #a9b2cc;
}

.dark .synthesis-item-name {
  color: #d7def7;
}

.dark .tip-mat {
  color: #a9b2cc;
}

.dark .synthesis-card .mat-item,
.dark .synthesis-card .item-limit {
  color: #a9b2cc;
}

.dark .book-page {
  background: rgba(255, 255, 255, 0.03);
  border-color: #373e57;
}

.dark .drawer-section {
  border-color: #373e57;
  background: rgba(255, 255, 255, 0.03);
}

@media (max-width: 900px) {
  .book-body {
    grid-template-columns: 1fr;
  }

  .item-grid {
    grid-template-columns: repeat(3, minmax(0, 1fr));
    height: 360px;
  }

.synthesis-card .realm-line {
  color: #7b8494;
  white-space: nowrap;
}

.synthesis-card .realm-line .ivu-icon {
  color: #e6a23c;
  font-size: 12px;
}

  .right-page .item-grid {
    grid-template-columns: repeat(3, minmax(0, 1fr)) !important;
  }
}

@media (max-width: 560px) {
  .item-grid {
    grid-template-columns: repeat(3, minmax(0, 1fr));
    height: 360px;
    gap: 6px;
    padding: 4px;
  }

  .right-page .item-grid {
    grid-template-columns: repeat(3, minmax(0, 1fr)) !important;
  }

  .book-page {
    min-width: 0;
    padding: 8px;
  }

  .item-card {
    min-width: 0;
    width: 100%;
    padding: 7px !important;
  }

  .item-name,
  .synthesis-item-name {
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    white-space: normal !important;
    word-break: break-word;
    line-height: 1.25;
    min-height: 2.5em;
  }

  .synthesis-card {
    height: auto !important;
    min-height: 190px !important;
    max-height: none !important;
    padding: 8px !important;
  }

  .synthesis-card .content-area {
    min-height: 0;
    padding-top: 5px;
  }

  .synthesis-card .item-limit {
    margin-bottom: 5px;
    line-height: 1.25;
  }

  .item-actions {
    gap: 3px !important;
    flex-wrap: wrap !important;
  }

  .synthesis-card .action-buttons {
    gap: 3px !important;
    flex-wrap: nowrap !important;
    margin-top: auto;
  }

  .item-actions .ivu-btn,
  .synthesis-card .action-buttons .ivu-btn {
    min-width: 0 !important;
    flex: 1 1 0;
    height: 30px !important;
    padding: 0 3px !important;
    font-size: 11px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/synthesisNew.vue